import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Search } from "lucide-react";
import { companyLookupAPI } from "@/lib/api";

export function CompanyLookup({ onSelect, className = "" }) {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [searching, setSearching] = useState(false);
  const [showResults, setShowResults] = useState(false);

  const search = async () => {
    if (query.length < 2) return;
    setSearching(true);
    try {
      const r = await companyLookupAPI.search(query);
      setResults(r.data.results || []);
      setShowResults(true);
    } catch { setResults([]); }
    finally { setSearching(false); }
  };

  const handleKeyDown = (e) => { if (e.key === "Enter") { e.preventDefault(); search(); } };

  return (
    <div className={`relative ${className}`} data-testid="company-lookup">
      <Label className="text-xs text-slate-500">Recherche entreprise (API Sirene)</Label>
      <div className="flex gap-2 mt-1">
        <Input value={query} onChange={e => setQuery(e.target.value)} onKeyDown={handleKeyDown} placeholder="Nom, SIRET ou SIREN..." className="flex-1" data-testid="company-lookup-input" />
        <Button type="button" variant="outline" onClick={search} disabled={searching || query.length < 2} data-testid="company-lookup-btn">
          <Search size={16} className="mr-1" />{searching ? "..." : "Rechercher"}
        </Button>
      </div>
      {showResults && results.length > 0 && (
        <div className="absolute z-50 mt-1 w-full bg-white border border-slate-200 rounded-lg shadow-lg max-h-64 overflow-y-auto" data-testid="company-lookup-results">
          {results.map((r, i) => (
            <button key={r.siren || `company-${i}`} type="button" className="w-full text-left px-3 py-2.5 hover:bg-indigo-50 border-b border-slate-100 last:border-0 transition-colors" onClick={() => { onSelect(r); setShowResults(false); setQuery(""); }} data-testid={`company-result-${i}`}>
              <p className="text-sm font-medium text-slate-800">{r.nom}</p>
              <p className="text-xs text-slate-500">SIRET: {r.siret || "?"} &middot; {r.code_postal} {r.ville}</p>
            </button>
          ))}
        </div>
      )}
      {showResults && results.length === 0 && !searching && (
        <div className="absolute z-50 mt-1 w-full bg-white border border-slate-200 rounded-lg shadow-lg p-3 text-center text-sm text-slate-400">Aucun résultat</div>
      )}
      {showResults && <div className="fixed inset-0 z-40" onClick={() => setShowResults(false)} />}
    </div>
  );
}
